import React, { createContext, useContext } from 'react';
import baseline from './baseline';
import './AppUiScope.css';
import { useColorScheme } from '../contexts/ColorSchemeContext';
const AppUiContext = createContext(false);
export const useAppUi = () => useContext(AppUiContext);
export default function AppUiScope({ className = '', children, surface, ...elementProps }) {
  const { resolvedMode } = useColorScheme();
  const colors = baseline.tokens[resolvedMode === 'dark' ? 'darkColors' : 'lightColors'];
  const text = baseline.contentText;
  const variables = {};
  for (const [key, value] of Object.entries(text)) {
    variables[`--app-${key}-size`] = `${value.fontSize}px`;
    variables[`--app-${key}-line`] = `${value.lineHeight}px`;
    variables[`--app-${key}-weight`] = value.fontWeight;
    variables[`--app-${key}-spacing`] = `${value.letterSpacing || 0}px`;
  }
  variables['--app-recent-width'] = `${baseline.home.recentCard.width}px`;
  variables['--app-recent-gap'] = `${baseline.home.recentCard.gap}px`;
  variables['--app-recent-image-gap'] = `${baseline.home.recentImage.marginBottom}px`;
  variables['--app-recent-rail-gap'] = `${baseline.home.recentRail.gap}px`;
  if (baseline[surface]?.sections)
    variables['--app-mobile-section-gap'] = `${baseline[surface].sections.gap}px`;
  if (surface === 'lists') {
    variables['--app-review-body'] = colors.reviewBody;
    variables['--app-surface-soft'] = colors.surfaceSoft;
    variables['--app-inline-height'] = `${baseline.lists.inlineAd.inlineCard.minHeight}px`;
    variables['--app-inline-radius'] = `${baseline.lists.inlineAd.inlineCard.borderRadius}px`;
    const { reviews, tile } = baseline.lists;
    const values = {
      'feed-gap': reviews.feedRow.gap,
      'feed-padding': reviews.feedRow.paddingVertical,
      'feed-cover': reviews.feedCover.width,
      'feed-copy-gap': reviews.feedAlbumCopy.gap,
      'copy-gap': tile.copy.gap,
      'cover-gap': tile.wrap.gap,
      'rating-gap': baseline.contentRating.gap,
      'rating-star': baseline.contentRating.starSize,
    };
    for (const [key, value] of Object.entries(values)) variables[`--app-${key}`] = `${value}px`;
  }
  return (
    <AppUiContext.Provider value={true}>
      <div {...elementProps} className={`${className} pp-app-ui-scope`} style={variables}>
        {children}
      </div>
    </AppUiContext.Provider>
  );
}
